module.exports = __webpack_public_path__ + "053569ece30fd95ee1efece623e2c7f7.svg";